import { render, staticRenderFns } from "./TsgDictionaryForDxp.vue?vue&type=template&id=2f12291f&"
import script from "./TsgDictionaryForDxp.vue?vue&type=script&lang=js&"
export * from "./TsgDictionaryForDxp.vue?vue&type=script&lang=js&"
import style0 from "./TsgDictionaryForDxp.vue?vue&type=style&index=0&id=2f12291f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports